<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-3">
        <div class="row">
          <div class="col-md-6 ts-space-y-3">
            <div class="row">
              <div class="col-md-12">
                <label class=" ts-mb-0 required ts-font-robot">{{
                  $t('projectProfile.code')
                }}</label>
                <input
                  v-model="model.project_code"
                  type="text"
                  class="form-control"
                  placeholder="Input project code. ex: 0000-000"
                />
                <div class="validate" v-if="errors.has('project_code')">
                  {{ errors.first('project_code') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class=" ts-mb-0 required ts-font-robot">{{
                  $t('projectProfile.name')
                }}</label>
                <input
                  v-model="model.project_name"
                  type="text"
                  class="form-control"
                  placeholder="Input project name. ex: UX/UI Design"
                />
                <div class="validate" v-if="errors.has('project_name')">
                  {{ errors.first('project_name') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class=" ts-mb-0 required ts-font-robot">{{
                  $t('projectProfile.status')
                }}</label>
                <a-select
                  v-model="model.status_id"
                  :options="projectStatus"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  placeholder="Select status project"
                  disabled
                ></a-select>
                <div class="validate" v-if="errors.has('status_id')">
                  {{ errors.first('status_id') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class=" ts-mb-0 ts-font-robot">{{
                  $t('projectProfile.priority')
                }}</label>
                <a-select
                  v-model="model.priority_id"
                  :options="priorities"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  placeholder="Select who is main response"
                ></a-select>
                <div class="validate" v-if="errors.has('priority_id')">
                  {{ errors.first('priority_id') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class=" ts-mb-0 ts-font-robot">{{
                  $t('projectProfile.owner')
                }}</label>
                <a-select
                  v-model="model.project_owner"
                  :options="owners"
                  show-search
                  :allowClear="true"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  placeholder="Select who is main response"
                ></a-select>
                <div class="validate" v-if="errors.has('project_owner')">
                  {{ errors.first('project_owner') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class=" ts-mb-0 ts-font-robot">{{
                  $t('projectProfile.estimated')
                }}</label>
                <div class="ts-flex ts-justify-between ts-space-x-2">
                  <a-date-picker
                    v-model="model.estimated_start_date"
                    format="DD-MM-YYYY"
                    valueFormat="DD-MM-YYYY"
                    class="ts-w-full"
                    placeholder="Start date"
                    :disabled-date="disabledEstimatedStartDate"
                  />
                  <a-date-picker
                    v-model="model.estimated_end_date"
                    format="DD-MM-YYYY"
                    valueFormat="DD-MM-YYYY"
                    class="ts-w-full"
                    placeholder="End date"
                    :disabled-date="disabledEstimatedEndDate"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class=" ts-mb-0 ts-font-robot ts-capitalize">{{
                  $t('projectProfile.actual')
                }}</label>

                <div class="ts-flex ts-justify-between ts-space-x-2">
                  <a-date-picker
                    v-model="model.actual_start_date"
                    format="DD-MM-YYYY"
                    valueFormat="DD-MM-YYYY"
                    class="ts-w-full"
                    placeholder="Start date"
                    :disabled-date="disabledActualStartDate"
                  />
                  <a-date-picker
                    v-model="model.actual_end_date"
                    format="DD-MM-YYYY"
                    valueFormat="DD-MM-YYYY"
                    class="ts-w-full"
                    placeholder="End date"
                    :disabled-date="disabledActualEndDate"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 ts-space-y-3">
            <div class="row">
              <div class="col-md-12">
                <label class=" ts-mb-0 ts-font-robot">{{
                  $t('projectProfile.customer')
                }}</label>
                <a-select
                  v-model="model.customer_id"
                  :options="customers"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="ts-w-full"
                  placeholder="Select customer name"
                ></a-select>
                <div class="validate" v-if="errors.has('customer_id')">
                  {{ errors.first('customer_id') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class=" ts-mb-0 ts-font-robot">{{
                  $t('projectProfile.address')
                }}</label>
                <textarea
                  v-model="model.project_address"
                  class="form-control"
                  placeholder="Describe the place of you project"
                  rows="5"
                ></textarea>
                <div class="validate" v-if="errors.has('project_address')">
                  {{ errors.first('project_address') }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class=" ts-mb-0 ts-font-robot">{{
                  $t('projectProfile.description')
                }}</label>
                <textarea
                  v-model="model.project_description"
                  placeholder="Describe any info for project"
                  class="form-control"
                  rows="13"
                ></textarea>
                <div class="validate" v-if="errors.has('project_description')">
                  {{ errors.first('project_description') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <AttachFile v-model="attachment" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2">
            <ts-button :disabled="loading" @click.prevent="$emit('cancel')"
              >{{ $t('cancel') }}
            </ts-button>
            <ts-button
              :disabled="loading"
              @click.prevent="saveAddNew"
              outline
              color="primary"
              >{{ $t('saveAddNew') }}
            </ts-button>
            <ts-button
              :disabled="loading"
              @click.prevent="save"
              color="primary"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import AttachFile from './components/attach-file.vue'
import moment from 'moment'

export default {
  components: {
    AttachFile
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      owners: [],
      customers: [],
      projectStatus: [],
      model: {
        project_id: '',
        project_code: 'P' + Math.floor(Date.now() / 7),
        project_name: '',
        project_address: '',
        project_owner: undefined,
        project_member: [],
        project_description: '',
        estimated_start_date: undefined,
        estimated_end_date: undefined,
        actual_start_date: undefined,
        actual_end_date: undefined,
        customer_id: '',
        status_id: 1,
        priority_id: ''
      },
      attachment: {
        files: []
      }
    }
  },
  created() {
    this.fetchViewModel()
    this.errors = new Errors()
    // this.model.project_owner = this.$store.state.authUser.user.user_id
  },
  computed: {
    priorities() {
      return [
        {
          label: 'Low',
          value: 1
        },
        {
          label: 'Normal',
          value: 2
        },
        {
          label: 'Meduim',
          value: 3
        },
        {
          label: 'Hight',
          value: 4
        }
      ]
    }
  },
  methods: {
    ...mapActions('projectMgt/projectProfile', [
      'formViewModel',
      'store',
      'attachFile'
    ]),
    fetchViewModel() {
      this.loading = true
      this.formViewModel({
        fnName: 'customer,status,owner'
      })
        .then(response => {
          this.owners = response.data.owner.map(el => ({
            value: el.user_id,
            label: el.employee_name_kh + '|' + el.employee_name_en
          }))
          this.customers = response.data.customer.map(el => ({
            value: el.customer_id,
            label: el.customer_name
          }))
          this.projectStatus = response.data.status.map(el => ({
            value: el.status_id,
            label: el.project_status
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    save() {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response =>
          this.onAttchmentFile(response.project.project_id).then(() => response)
        )
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveAddNew() {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response =>
          this.onAttchmentFile(response.project.project_id).then(() => response)
        )
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput() {
      this.model = {
        project_id: '',
        project_code: 'P' + Math.floor(Date.now() / 7),
        project_name: '',
        project_address: '',
        project_owner: undefined,
        project_member: [],
        project_description: '',
        estimated_start_date: undefined,
        estimated_end_date: undefined,
        actual_start_date: undefined,
        actual_end_date: undefined,
        customer_id: '',
        status_id: 1,
        priority_id: ''
      }
    },
    async onAttchmentFile(id) {
      if (this.attachment.files.length) {
        let formData = new FormData()
        formData.append('model_id', id ? id : this.model.project_id)
        formData.append('model_type', 'project')
        for (var i = 0; i < this.attachment.files.length; i++) {
          let file = this.attachment.files[i]
          formData.append('files[' + i + ']', file)
        }
        await this.attachFile(formData)
        this.attachment.files = []
      }

      return new Promise(r => r('done'))
    },
    disabledEstimatedStartDate(current) {
      return (
        this.model.estimated_end_date &&
        current &&
        current > moment(this.model.estimated_end_date, 'DD-MM-YYYY')
      )
    },
    disabledEstimatedEndDate(current) {
      return (
        this.model.estimated_start_date &&
        current &&
        current < moment(this.model.estimated_start_date, 'DD-MM-YYYY')
      )
    },
    disabledActualStartDate(current) {
      return (
        this.model.actual_end_date &&
        current &&
        current > moment(this.model.actual_end_date, 'DD-MM-YYYY')
      )
    },
    disabledActualEndDate(current) {
      return (
        this.model.actual_start_date &&
        current &&
        current < moment(this.model.actual_start_date, 'DD-MM-YYYY')
      )
    }
  }
}
</script>
